class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems = document.querySelector("cart-items");
      if (cartItems) {
        cartItems.updateQuantity(this.dataset.index, 0);
        // Call refreshCartSection after a short delay to ensure cart update is complete
        setTimeout(() => {
          if (typeof refreshCartSection === 'function') {
            refreshCartSection();
            console.log("refreshCartSection")
          }
        }, 500);
      } else {
        // fallback logic (e.g., reload page or section) 
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    this.setupQuantityDropdownListeners(); // Set up dropdown listeners
    this.setupOldQuantityInputListeners(); // Set up old quantity input listeners

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
    this.checkCartState();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  // Set up the dropdown quantity change listeners
  setupQuantityDropdownListeners() {
    const dropdowns = document.querySelectorAll(".quantity-dropdown");

    dropdowns.forEach((dropdown) => {
      const dropdownButton = dropdown.querySelector(".dropdown-btn");
      const dropdownList = dropdown.querySelector(".dropdown-list");
      const dropdownItems = dropdown.querySelectorAll(".dropdown-item");
      const line = dropdown.closest("[data-line]").dataset.line;

      // Toggle dropdown visibility
      dropdownButton.addEventListener("click", () => {
        const isVisible = dropdownList.style.display === "block";
        document
          .querySelectorAll(".dropdown-list")
          .forEach((list) => (list.style.display = "none"));
        document
          .querySelectorAll(".dropdown-btn")
          .forEach((btn) => btn.classList.remove("active"));
        dropdownList.style.display = isVisible ? "none" : "block";
        if (!isVisible) {
          dropdownButton.classList.add("active");
        }
      });

      // Handle item selection from dropdown
      dropdownItems.forEach((item) => {
        item.addEventListener("click", () => {
          const selectedValue = parseInt(item.getAttribute("data-value"));
          dropdownButton.dataset.selectedValue = selectedValue;
          dropdownList.style.display = "none"; // Hide the dropdown after selection
          dropdownButton.classList.remove("active");

          // Update quantity in the cart
          this.updateQuantity(line, selectedValue, dropdownButton);
        });
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", (event) => {
      if (!event.target.closest(".quantity-dropdown")) {
        document
          .querySelectorAll(".dropdown-list")
          .forEach((list) => (list.style.display = "none"));
        document
          .querySelectorAll(".dropdown-btn")
          .forEach((btn) => btn.classList.remove("active"));
      }
    });
  }

  // Preserve the old quantity input logic for other places where it is used
  setupOldQuantityInputListeners() {
    this.addEventListener("change", (event) => {
      if (event.target.classList.contains("quantity-input")) {
        const inputValue = parseInt(event.target.value);
        const index = event.target.dataset.index;
        this.updateQuantity(index, inputValue);
      }
    });
  }

  checkCartState() {
    // Fetch the cart state to check if it's empty
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const isEmpty = cart.item_count === 0;
        const featuredCategory = document.querySelector(
          ".cart-featured--category"
        );
        const featuredCollection = document.querySelector(
          ".featured-collection"
        );
        const cartFooterWrapper = document.querySelector(
          ".cart__footer-wrapper"
        );

        if (isEmpty) {
          // Reorder sections for an empty cart
          if (featuredCategory && featuredCollection && cartFooterWrapper) {
            const parent = featuredCategory.parentElement;

            // Append the elements in the desired order
            parent.appendChild(featuredCategory);
            parent.appendChild(featuredCollection);
            parent.appendChild(cartFooterWrapper);
          }
        }

        // Hide or show elements based on cart state
        document
          .querySelectorAll(".lm-coupon--codeSection")
          .forEach((element) => {
            element.style.display = isEmpty ? "none" : "flex";
          });
        document
          .querySelectorAll(".cart-featured--category")
          .forEach((element) => {
            element.style.display = isEmpty ? "block" : "none";
          });
        document
          .querySelectorAll(".lm-gift--wrapSection")
          .forEach((element) => {
            element.style.display = isEmpty ? "none" : "block";
          });
        document.querySelectorAll("#lm-pickup").forEach((element) => {
          element.style.display = isEmpty ? "none" : "block";
        });
        if(window.hwCurrencyConverterLoad){
          window.hwCurrencyConverterLoad()
          }
      })
      .catch((error) => console.error("Error fetching cart state:", error));
  }

  // Update the quantity both from dropdown and input
  updateQuantity(line, quantity, dropdownButton = null) {
    const cartCountSpan = document.querySelector("#cart_count span");
    if (cartCountSpan) {
        cartCountSpan.textContent = "";
    }
   
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        let parsedState = JSON.parse(state);

        this.checkCartState();
        if (parsedState.items?.length) {
          let giftItem = parsedState.items.find(
            (data) => data.product_type === "gift_wrapper"
          );
          if (!giftItem) {
            const removeGiftCardButton = document.querySelector(
              ".lm-remove--giftCard"
            );
            const showWhenClear = document.querySelector(".show_whn_clear");
            const wrapBoxText = document.querySelector(
              ".lm-gift--wrapBox__text"
            );
            const show_whn_add_to_cart = document.querySelector(
              ".show_whn_add_to-cart"
            );
            // const show_when_msg = document.querySelector(".show_when_msg");
            showWhenClear.style.display = "none";
            removeGiftCardButton.style.display = "none";
            wrapBoxText.style.display = "block";
            show_whn_add_to_cart.style.display = "none";
            // show_when_msg.style.display = "none";
          }
        } else {
          document
            .querySelectorAll(".lm-gift--wrapSection")
            .forEach((element) => {
              element.style.display = "none";
            });
          document.querySelectorAll(".lm-coupon_section").forEach((element) => {
            element.style.display = "none";
          });
        }

        if (parsedState?.items?.length === 1) {
          let giftItem = parsedState.items.find(
            (data) => data.product_type === "gift_wrapper"
          );
          if (giftItem) {
            await fetch("/cart/clear.js", { method: "POST" });
            document
              .querySelectorAll(".lm-coupon--codeSection")
              .forEach((element) => {
                element.style.display = "none";
              });
            document
              .querySelectorAll(".cart-featured--category")
              .forEach((element) => {
                element.style.display = "block";
              });
            document
              .querySelectorAll(".lm-gift--wrapSection")
              .forEach((element) => {
                element.style.display = "none";
              });
            document.querySelectorAll("#lm-pickup").forEach((element) => {
              element.style.display = "none";
            });
            document.querySelector("#cart-errors").style.display = "none";
            const featuredCategory = document.querySelector(
              ".cart-featured--category"
            );
            const featuredCollection = document.querySelector(
              ".featured-collection"
            );
            const cartFooterWrapper = document.querySelector(
              ".cart__footer-wrapper"
            );
            const parent = featuredCategory.parentElement;
            parent.appendChild(featuredCategory);
            parent.appendChild(featuredCollection);
            parent.appendChild(cartFooterWrapper);

            const updatedCartResponse = await fetch("/cart.js");
            parsedState = await updatedCartResponse.json();
          }
        }

        const cartCountSpan = document.querySelector("#cart_count span");
        if (cartCountSpan) {
            cartCountSpan.textContent = `(${parsedState.item_count})`;
        }


        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.commonCouponCodeFn();

        // Re-find the dropdown button after the sections have been updated
        if (dropdownButton) {
          const updatedDropdownButton = document.querySelector(
            `.quantity-dropdown[data-line="${line}"] .dropdown-btn`
          );

          if (updatedDropdownButton) {
            const selectedValue = dropdownButton.dataset.selectedValue;
            updatedDropdownButton.textContent = `QTY ${selectedValue}`;
          } else {
            console.log("Updated dropdown button not found!");
          }
        } else {
          console.log("No dropdownButton provided to update.");
        }

        this.setupQuantityDropdownListeners();
        this.setupOldQuantityInputListeners();
        if (
          parsedState.cart_level_discount_applications &&
          parsedState.cart_level_discount_applications.length > 0
        ) { 
          document.querySelector(".lm-coupen--codeForm").style.display = "none";
          document.body.classList.remove("lm-coupen--open");
          document.querySelector(".lm-coupen--applied").style.display = "flex";
          document.querySelector(".lm-coupen--appliedRemove").style.display =
            "flex";
          document.querySelector("#lm_apply_coupon_code").style.pointerEvents =
            "none";
        } else {
          document.querySelector(".lm-coupen--codeForm").style.display = "none";
          document.querySelector(".lm-coupen--applied").style.display = "none";
          document.querySelector(".lm-coupen--appliedRemove").style.display =
            "none";
          document.querySelector("#lm_apply_coupon_code").style.pointerEvents =
            "all";
          document.querySelector("#lm_apply_coupon_code").style.display =
            "flex";
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
        });
      })
      .catch((error) => {
        // console.error("Error during cart update:", error);
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        if (errors) { // Check if errors element exists
          errors.textContent = window.cartStrings.error;
        }
      })
      .finally(() => {
        this.disableLoading(line);
        if(window.hwCurrencyConverterLoad){
          window.hwCurrencyConverterLoad()
          }
      });
  }

// Add the function to update existing product options
// updateProductOptions(items) {
//   items.forEach((item) => {
//       if (item.product_type === "gift_wrapper") {
//           return; // Skip if it is a gift wrapper
//       }

//       // Iterate over each product option
//       item.properties.forEach((property, key) => {
//           // Dynamically create the class name for the option
//           const optionClass = `hw__product-option_${key.toLowerCase().replace(/ /g, '-')}`;
//           const optionElement = document.querySelector(`.product-option.${optionClass}`);

//           // Only update the existing option if it exists, and do not create new ones
//           if (optionElement) {
//               const optionValue = optionElement.querySelector("dd");

//               // Update the option value if the element exists
//               if (optionValue) {
//                   optionValue.textContent = property; // Update the <dd> with the new value
//               }
//           } else {
//               console.log(`Product option ${key} does not exist!`);
//           }
//       });
//   });
// }



  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) => 
      overlay.classList.add("hidden")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (inputValue % parseInt(event.target.step) !== 0 && Number.isNaN(parseInt(hello) % parseInt(step))) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  commonCouponCodeFn() {
    this.checkCartForAppliedCoupon();
    this.setupEventListeners();
  }

  async checkCartForAppliedCoupon() {
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) {
        throw new Error("Failed to fetch cart data.");
      }

      const cartData = await response.json();
      // console.log(cartData);

      // Check if there are any active discount applications
      if (
        cartData.cart_level_discount_applications &&
        cartData.cart_level_discount_applications.length > 0
      ) {
        // If a coupon is applied, update the state in local storage
        window.localStorage.setItem("couponApplied", "true");

        // Apply post-refresh changes
        setTimeout(() => {
          this.applyPostRefreshCouponChanges();
        }, 900);
      } else {
        window.localStorage.setItem("couponRemoved", "true");
        setTimeout(() => {
          this.removePostRefreshCouponChanges();
        }, 900);
      }
    } catch (error) {
      console.error("Error checking cart for applied coupon:", error);
    }
  }

  applyPostRefreshCouponChanges() {
    if (window.localStorage.getItem("couponApplied") === "true") {
      document.querySelector(".lm-coupen--codeForm").style.display = "none";
      document.body.classList.remove("lm-coupen--open");
      document.querySelector(".lm-coupen--applied").style.display = "flex";
      document.querySelector(".lm-coupen--appliedRemove").style.display =
        "flex";
      document.querySelector("#lm_apply_coupon_code").style.pointerEvents =
        "none";

      document.querySelector("#lm_apply_coupon_code").style.display = "none";

      // Remove the flag from local storage after applying changes
      window.localStorage.removeItem("couponApplied");
    }
  }
  removePostRefreshCouponChanges() {
    if (window.localStorage.getItem("couponRemoved") === "true") {
      document.querySelector(".lm-coupen--codeForm").style.display = "block";
      document.querySelector(".lm-coupen--codeForm").classList.add("show");
      document.body.classList.add("lm-coupen--open");

      document.querySelector(".lm-coupen--applied").style.display = "none";
      document.querySelector(".lm-coupen--appliedRemove").style.display =
        "none";
      document.querySelector("#lm_apply_coupon_code").style.pointerEvents =
        "all";
      document.querySelector("#lm_apply_coupon_code").style.display = "flex";

      window.localStorage.removeItem("couponRemoved");
    }
  }

  clearCouponCode() {
    // const applyValue = document.querySelector(".apply-discount-code--value");
    // if (applyValue) {
    //   applyValue.value = "";
    // }
  }

  addRemoveCouponListener() {
    // const removeBtn = document.querySelector(".lm-coupen--appliedRemove");
    // if (removeBtn) {
    //   removeBtn.addEventListener("click", async () => {
    //     this.clearCouponCode();
    //     await this.applyCouponCode("");
    //   });
    // }
  }

  applyDiscountCodeOnCart() {
    // const applyBtn = document.querySelector(".apply-discount-code--btn");
    // const applyValue = document.querySelector(".apply-discount-code--value");

    // if (applyBtn) {
    //   applyBtn.addEventListener("click", async () => {
    //     if (applyValue && applyValue.value.trim() !== "") {
    //       await this.applyCouponCode(applyValue.value);
    //     } else {
    //       if (applyValue) {
    //         applyValue.focus();
    //       }
    //       return false;
    //     }
    //   });
    // }
  }

  async refreshCart() {
    try {
      const response = await fetch("/cart?view=ajax");
      if (!response.ok) {
        throw new Error("Failed to refresh cart.");
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const updatedCartItems = doc.querySelector("#main-cart-items .js-contents").innerHTML;

      document.querySelector("#main-cart-items .js-contents").innerHTML =updatedCartItems;

      const updatedFooter = doc.querySelector("#main-cart-footer .js-contents").innerHTML;

      document.querySelector("#main-cart-footer .js-contents").innerHTML =updatedFooter;

      // Reinitialize event listeners after refresh
      this.setupEventListeners();
    } catch (error) {
      console.error("Error refreshing cart:", error);
    } finally{
      if(window.hwCurrencyConverterLoad){
        window.hwCurrencyConverterLoad()
        }
    }
  }

  setupEventListeners() {
    this.applyDiscountCodeOnCart();
    this.addRemoveCouponListener();
  }

  getCartTokenCookie(name) {
    let matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
          "=([^;]*)"
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  getcartId() {
    const cartToken = this.getCartTokenCookie("cart");
    if (cartToken) {
      return `gid://shopify/Cart/${cartToken}`;
    }
    return null;
  }

  async shopify_graphql_call(data) {
    const SHOPIFY_STORE_FRONT_TOKEN = "a029d832714a77943e1da235921e92d3";
    const SHOP_NAME = "lialijewellery";
    try {
      const shopifyEndpoint = `https://${SHOP_NAME}.myshopify.com/api/2024-04/graphql.json`;
      const shopifyAccessToken = SHOPIFY_STORE_FRONT_TOKEN;
      const payload = {
        query: data?.query,
      };
      if (data?.variables) {
        payload["variables"] = data?.variables;
      }
      const res = await fetch(shopifyEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": shopifyAccessToken,
        },
        body: JSON.stringify(payload),
      });
      const result = await res.json();
      if (result) {
        return result;
      }
    } catch (error) {
      console.error(error);
    }
  }

  async applyCouponCode(discountCode) {
    const CART_ID = this.getcartId();
    if (CART_ID) {
      const variables = {
        cartId: CART_ID,
        discountCodes: discountCode ? [discountCode] : [],
      };
      const query = `
              mutation CartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
                cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                  userErrors {
                    message
                    field
                    code
                  }
                  cart { 
                    discountCodes {
                      code
                      applicable
                    }
                    id
                  }
                }
              }
              `;
      const result = await this.shopify_graphql_call({ query, variables });

      if (result) {
        const discountCodesArray =
          result?.data?.cartDiscountCodesUpdate?.cart?.discountCodes;

        if (!discountCodesArray?.length) {
          window.localStorage.setItem("couponRemoved", "true");
          await this.refreshCart();
          setTimeout(() => {
            this.removePostRefreshCouponChanges();
          }, 900);
        } else {
          const discountCode = discountCodesArray[0];
          if (discountCode?.applicable) {
            window.localStorage.setItem("couponApplied", "true");
            await this.refreshCart();
            setTimeout(() => {
              this.applyPostRefreshCouponChanges();
            }, 900);
          } else {
            document.querySelector(".coupon-error_code").innerHTML +=
              "<p>Coupon code doesn't exist</p>";
            setTimeout(function () {
              document.querySelector(".coupon-error_code").innerHTML = "";
            }, 2000);
          }
        }
      } else {
        console.log("No result from API");
      }
    }
  }

  resetQuantityInput(id) {
    const input = document.querySelector(`#Quantity-${id}`);
    if (!input) {
      console.warn(`Input with ID Quantity-${id} not found.`);
      return;
    }
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }
  

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
          this.checkCartState();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
}

// Define the CartItems element
customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();
 
        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

window.updateQuantity = (line, quantity, dropdownButton = null) => {
  const cartItems = document.querySelector("cart-items");
  if (cartItems) {
    cartItems.updateQuantity(line, quantity, dropdownButton);
  }
};